<template>
  <el-row :gutter="10">
    <el-col
      :xs="7"
      :sm="6"
      :md="6"
      :lg="5"
      :xl="5"
    >
      <Filters
        v-model="filters"
        :resource="$sdk.feedevent"
        :primary-fields="[
          'event_type',
          'created_at'
        ]"
        @keyup.enter.native="$emit('apply')"
      />
    </el-col>

    <el-col
      :xs="17"
      :sm="18"
      :md="18"
      :lg="19"
      :xl="19"
    >
      <el-card
        shadow="never"
        style="align-items: stretch; background: transparent; border: none;"
      >
        <Timeline
          v-loading="isLoading"
          :events="events"
          @load-events="fetchEvents"
        />
      </el-card>
    </el-col>
  </el-row>
</template>
<script>
import Timeline from '@/components/Application/Feed/Timeline'
import Filters from '@/components/Filters/Simplified/index.vue'

export default {
  name: 'Feed',
  components: {
    Filters,
    Timeline
  },
  data () {
    return {
      title: 'Activity Feed',
      pageTitle: 'Activity Feed',
      breadcrumb: {
        name: 'Activity Feed',
        route: { name: 'application-feed' }
      },
      filters: {},
      events: [],
      isLoading: false
    }
  },
  created () {
    this.fetchEvents()
  },
  methods: {
    async fetchEvents () {
      this.isLoading = true
      try {
        this.isLoading = false
        this
          .$sdk
          .feedevent
          .list(request => {
            request.order = 'created_at:desc'
          })
          .then(res => { this.events = res })
          .finally(() => { this.isLoading = false })
      } catch (error) {
        this.$message.error('Failed to load events.')
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
<style scoped>

</style>
